import React from 'react';
import { Icon } from '../icons';

// Campo di ricerca per le toolbar delle tabelle: icona di ricerca a sinistra,
// bottone "cancella" a destra quando c'e' un valore. Stesso onChange(e) delle
// input native (usa e.target.value), cosi' si integra senza cambiare i call site.
function SearchInput({ value, onChange, placeholder, className = '', id, ...rest }) {
  const clear = () => onChange({ target: { value: '' } });

  return (
    <div className={`search-field ${className}`.trim()}>
      <Icon name="search" size={16} className="search-field-icon" />
      <input
        id={id}
        type="text"
        className="input search-input"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...rest}
      />
      {value ? (
        <button type="button" className="input-action search-field-clear" onClick={clear} aria-label="Cancella ricerca">
          <Icon name="x" size={14} />
        </button>
      ) : null}
    </div>
  );
}

export default SearchInput;
